import React from "react";
import GoogleLogin from "react-google-login";

import ToastService from "../../service/toast-service";
import AuthService from "../../service/auth";
import { Row, Col, Img, Text } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { googleLogo } from "../../theme/image";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH;

export default ({ connected }) => {
  const success = (res) => {
    if (connected) {
      return ToastService.infoToast(
        "You have already connected your google account"
      );
    }
    const profile = res && res.profileObj;
    const { email, name, imageUrl, googleId } = profile;
    AuthService.connectGoogle({
      email,
      name,
      imageUrl,
      googleUserId: googleId,
    });
  };

  return (
    <Row
      style={{
        width: "100%",
        height: "20%",
        // justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Img height="40%" src={googleLogo} />
      <Col>
        <Row alignItems="center">
          <Text
            fontSize="22px"
            color={Theme.color.GRAY_1}
            fontFamily={Theme.fontFamily.recursive}
            fontWeight="600"
          >{`Google : `}</Text>
          <Text
            fontSize="18px"
            color={Theme.color.GRAY_0}
            fontFamily={Theme.fontFamily.recursive}
            fontWeight="600"
          >
            {connected ? "connected" : "not connected"}
          </Text>
        </Row>
        <GoogleLogin
          clientId={CLIENT_ID}
          buttonText={connected ? "Connnected" : "Connect with google"}
          onSuccess={success}
          cookiePolicy={"single_host_origin"}
        />
      </Col>
    </Row>
  );
};
